export default {
  replaceTitle: {
    id: 'STORY_HERO_REPLACE_TITLE',
    defaultMessage: '  Replace',
    description:
      'Select Story  > Select one asset > Make it story Hero > again try to replace asset',
  },
};
